import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';

export function dateDebutDejaValideeValidator(
  datesValidees: () => string[]
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    // moment() keeps the UTC mode set by the date picker (useUtc)
    const date = moment(control.value);
    if (!date.isValid()) {
      return null;
    }

    const jour = date.format('YYYY-MM-DD');

    return datesValidees().some(d => moment(d).format('YYYY-MM-DD') === jour)
      ? { dejaValidee: true }
      : null;
  };
}
